import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state:{
    cAeSatus: 1, // 中英文控制变量 1-中文 2-英文
    activedMenuIndex: 1 // 菜单控制变量
  },
  mutations: {
    setCAE (state, payload) {
      state.cAeSatus = payload
    },
    setActiviedMenuIndex (state,payload) {
      state.activedMenuIndex = payload
    },
  },
  getters: {
    getCSEStatus (state) {
      if (localStorage.getItem('cAeSatus')) {
        state.cAeSatus = localStorage.getItem('cAeSatus')
      }
      return state.cAeSatus
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js